import Tooltip from '@shared/components/ui/tooltip/tooltip';

interface GenerationIdCellProps {
  generationId: string;
}

/** Celda de ID generación: una línea alineada como el resto; UUID completo en tooltip */
export const GenerationIdCell = ({ generationId }: GenerationIdCellProps) => (
  <Tooltip
    content={<span className="block max-w-sm break-all font-mono text-xs">{generationId}</span>}
    trigger={
      <span
        className="block w-full truncate font-mono text-xs text-title"
        data-testid="payment-file-generation-id-cell"
      >
        {generationId}
      </span>
    }
    side="top"
    data-testid="payment-file-generation-id-tooltip"
  />
);
